import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ValueFirstOnboardingService } from '../../services/value-first-onboarding.service';
import { BRAND_TRIAL_LINE, ValueFirstStep, brandInitial } from '../../services/value-first-onboarding.types';

@Component({
  selector: 'vf-workspace-panel',
  templateUrl: './workspace-panel.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'hidden h-full min-h-0 lg:block lg:w-1/2' },
})
export class VfWorkspacePanel {
  readonly onboarding = inject(ValueFirstOnboardingService);

  readonly filled = computed(() => {
    const step = this.onboarding.step();
    return step === 'found' || step === 'email' || step === 'code' || step === 'account' || step === 'welcome';
  });

  readonly claimPitch = computed(() => this.onboarding.step() === 'found');

  readonly trialLine = computed(() => {
    const currency = this.onboarding.displayCurrency();
    return currency ? BRAND_TRIAL_LINE[currency] : '14-day free trial. Cancel anytime.';
  });

  readonly label = computed(() => {
    const step = this.onboarding.step();
    if (step === 'found') {
      return 'Why claim it';
    }
    if (step === 'welcome') {
      return 'Your SHOUT workspace is live';
    }
    if (this.filled()) {
      return 'Your SHOUT workspace';
    }
    return 'Your SHOUT workspace appears here';
  });

  readonly ownerLabel = computed(() => {
    const step = this.onboarding.step();
    const email = this.onboarding.draft().email.trim();
    if (step === 'welcome') {
      return email ? `Owner: ${email}` : 'Owner';
    }
    if ((step === 'email' || step === 'code' || step === 'account') && email.includes('@')) {
      return `Reserved for ${email}`;
    }
    return 'Not claimed yet';
  });

  readonly status = computed(() => this.statusFor(this.onboarding.step(), this.onboarding.draft().email));

  initial(): string {
    return brandInitial(this.onboarding.brandName());
  }

  private statusFor(step: ValueFirstStep, email: string): { label: string; live: boolean } {
    if (step === 'welcome') {
      return { label: 'Live', live: true };
    }
    if (step === 'found' || ((step === 'email' || step === 'code' || step === 'account') && email.includes('@'))) {
      return { label: 'Reserved', live: false };
    }
    return { label: 'Draft', live: false };
  }
}
